// src/components/Projects.js
import { useState } from 'react';
import { projects } from '../data';
import ProjectCard from './ProjectCard';
import './Projects.css';

const Projects = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <section id="projects" className="projects-section">
      <h2 onClick={() => setCollapsed(!collapsed)} className="section-header-clickable">
        Mes Projets
        <span className="toggle-icon">{collapsed ? '▼' : '▲'}</span>
      </h2>
      {!collapsed && (
        <div className="projects-grid">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      )}
    </section>
  );
};

export default Projects;